<template>
  <div class="programs">
    <template v-if="isFetching">
      <div class="p-5 d-flex justify-content-center align-items-center">
        <v-loader />
      </div>
    </template>
    <template v-else>
      <template v-if="isAuthenticated && userHasProgramSubscriptions">
        <list boxed class="mt-3">
          <list-item chevron @click="() => $router.push('/me/my-content')">
            <template slot="left">
              <v-icon icon="favorite" class="color-brand" />
            </template>
            <div class="v-list-item__title --centered ml-2">
              {{ $t("components.discover.programs.viewProgram") }}
            </div>
          </list-item>
        </list>
      </template>
      <template v-if="programs.length > 0">
        <collection direction="vertical" :items="programs" unlock />
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import Collection from "@/components/Collection"
import List from "@/components/List"
import ListItem from "@/components/ListItem"

export default {
  props: {
    active: { type: Boolean, default: false }
  },

  components: {
    Collection,
    List,
    ListItem
  },

  data() {
    return {
      isFetching: false,
      programs: []
    }
  },

  computed: {
    ...mapGetters("programs", ["userHasProgramSubscriptions"]),
    ...mapGetters("auth", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("programs", ["fetchPrograms"])
  },

  mounted() {
    this.isFetching = true

    this.fetchPrograms()
      .then(programs => {
        this.programs = programs
      })
      .finally(() => (this.isFetching = false))
  }
}
</script>
